import { IPointerEvent, Observable, PickingInfo } from '@babylonjs/core';

import { PostprocessOptions } from '../graphic';

export const onFirstModelLoaded = new Observable<void>();
export const onAllModelLoaded = new Observable<void>();
export const onModelLoadProgress = new Observable<number>();
export const onResize = new Observable<void>();
export const onUpdatePostprocessOptionsFromJson = new Observable<PostprocessOptions>();

export const onTouchStartObservable = new Observable<TouchEvent | IPointerEvent>();
export const onTouchMovedObservable = new Observable<TouchEvent | IPointerEvent>();
export const onTouchEndObservable = new Observable<TouchEvent | IPointerEvent>();
export const onTouchTapObservable = new Observable<TouchEvent | IPointerEvent>();
export const onPickedObservable = new Observable<PickingInfo>();
export const onMousewheelObservable = new Observable<TouchEvent | IPointerEvent>();


export const clearCommonObservable = () => {
  onFirstModelLoaded.clear();
  onAllModelLoaded.clear();
  onModelLoadProgress.clear();
  onResize.clear();
  onUpdatePostprocessOptionsFromJson.clear();

  onTouchStartObservable.clear();
  onTouchMovedObservable.clear();
  onTouchEndObservable.clear();
  onTouchTapObservable.clear();
  onPickedObservable.clear();
  onMousewheelObservable.clear();
};
